<template>
  <div>
    <div class="Breadcrumb u-desktopOnly">
      <ul>
        <li class="Breadcrumb__item">
          <router-link to="/">{{ $t("home") }}</router-link>
        </li>
        <li class="Breadcrumb__item">
          <span>{{ $t("cookiePolicy") }}</span>
        </li>
      </ul>
    </div>

    <div class="RichTextArea">
      <h1><center>Cookies and Similar Tracking Technologies Policy</center></h1>
      <p>
        This cookies and similar technologies policy provides you with general
        information about cookies and similar technologies (collectively,
        &ldquo;<strong>Tracking Technologies</strong>&rdquo;) as well as how and
        for what purposes Pomvom (&ldquo;<strong>we</strong>&rdquo;,
        &ldquo;<strong>our</strong>&rdquo; or &ldquo;<strong>us</strong>&rdquo;)
        use such Tracking Technologies on our website
        (&ldquo;<strong>Site</strong>&rdquo;).
      </p>
      <p>
        Please take the time to read this policy, which complements our general
        privacy policy. If you have questions or comments, you are welcome to
        contact us at
        <a href="mailto:privacy@pomvom.com">privacy@pomvom.com</a>.
      </p>
      <p><center><strong>Index</strong></center></p>
      <ul>
        <li>
          <em><a
                    href="javascript:void(0)"
                    @click="scrollToRef('cookies')"
                    >What Are &lsquo;Cookies&rsquo;?</a></em>
        </li>
        <li>
          <em><a
                    href="javascript:void(0)"
                    @click="scrollToRef('purpose')"
                    >For What Purposes are Cookies Being Used?</a></em>
        </li>
        <li>
          <em
            ><a
                    href="javascript:void(0)"
                    @click="scrollToRef('session')"
                    >What are &lsquo;Session&rsquo; and &lsquo;Persistent&rsquo;
              Cookies?</a
            ></em
          >
        </li>
        <li>
          <em
            ><a
                    href="javascript:void(0)"
                    @click="scrollToRef('party')"
                    >What are &lsquo;First-party&rsquo; and &lsquo;Third-party&rsquo;
              Cookies?</a
            ></em
          >
        </li>
        <li>
          <em><a
                    href="javascript:void(0)"
                    @click="scrollToRef('similar')"
                    >What are &lsquo;Similar Technologies&rsquo;?</a></em>
        </li>
        <li>
          <em
            ><a
                    href="javascript:void(0)"
                    @click="scrollToRef('tracking')"
                    >How do we Use Tracking Technologies and for What Purposes?</a
            ></em
          >
        </li>
        <li>
          <em
            ><a
                    href="javascript:void(0)"
                    @click="scrollToRef('consent')"
                    >Do we Need to Obtain my Consent for Using Tracking
              Technologies?</a
            ></em
          >
        </li>
        <li>
          <em><a
                    href="javascript:void(0)"
                    @click="scrollToRef('preferences')"
                    >Can I Manage my Tracking Technologies Preferences?</a></em>
        </li>
        <li>
          <em><a
                    href="javascript:void(0)"
                    @click="scrollToRef('updates')"
                    >Will we Update this Policy?</a></em>
        </li>
      </ul>
      <p ref="cookies"><center><strong>What Are &lsquo;Cookies&rsquo;?</strong></center></p>
      <p>
        Cookies are small files with pieces of information, normally consisting
        of just letters and numbers, which websites use when users visit them.
      </p>
      <p>
        Software on the users&rsquo; devices (for example, a web browser) can
        store cookies and send them back to the website the next time they
        visit, to make a specific function of the website work and to provide
        information about the user&rsquo;s activities on the website.
      </p>
      <p ref="purpose"><center><strong>For What Purposes are Cookies Being Used?</strong></center></p>
      <p>
        Cookies are used in numerous ways. For example, when analyzing traffic
        to a website or tracking users' browsing behavior.
      </p>
      <p>
        Cookies are widely used as they allow a website to recognize a
        user&rsquo;s device. Tracking Technologies help websites to remember the
        visitors and their activities, for example, the user&rsquo;s language
        preferences.
      </p>
      <p ref="session">
        <center><strong
          >What are &lsquo;Session&rsquo; and &lsquo;Persistent&rsquo;
          Cookies?</strong
        ></center>
      </p>
      <p>
        &ldquo;Session Cookies&rdquo; are removed from user&rsquo;s device once
        they close their browser session.
      </p>
      <p>
        &ldquo;Persistent Cookies&rdquo; last for longer periods on your device
        - after users close their browser session.
      </p>
      <p>
        Users can delete previously set persistent cookies manually or configure
        the browser settings to delete cookies, as further described below.
      </p>
      <p ref="party">
        <center><strong
          >What are &lsquo;First-party&rsquo; and &lsquo;Third-party&rsquo;
          Cookies?</strong
        ></center>
      </p>
      <p>
        First-party cookies are set directly by the website that the users are
        visiting.
      </p>
      <p>
        Third-party cookies are set by a domain other than the one the users are
        visiting. For the purpose of this policy, these are cookies that are set
        by our service providers, such as Google Analytics.
      </p>
      <p ref="similar"><center><strong>What are &lsquo;Similar Technologies&rsquo;?</strong></center></p>
      <p>
        Functions usually performed by a cookie can be achieved by other means.
        This could include, for example, using certain characteristics to
        identify devices so that visits to a website can be analyzed.
      </p>
      <p>
        Any technology that stores or accesses information on your device is
        relevant for this purpose, and therefore it includes, for example, HTML5
        local storage, Local Shared Objects, and fingerprinting techniques.
      </p>
      <p>
        Additionally, technologies like use of log files, scripts, tracking
        pixels and plugins, wherever these are used &ndash; are also considered
        as similar technologies.
      </p>
      <p ref="tracking">
        <center><strong
          >How do we Use Tracking Technologies and for What Purposes?</strong
        ></center>
      </p>
      <p>
        We use both Session Cookies and Persistent Cookies as part of your
        experience on the Site so that we can facilitate the use of the
        Site&rsquo;s features and tools, keep track of your preferences, improve
        your experience with our Site, for web analytics and for marketing
        purposes.
      </p>
      <p>
        Some cookies are strictly essential for the operation of the Site while
        other cookies help to improve our services and marketing activities. The
        same rule goes for all Tracking Technologies that we use.
      </p>
      <p>
        The cookie management tool that we use&nbsp;(&ldquo;<strong
          >Cookie Management Tool</strong
        >&rdquo;) provides you with a clear and comprehensive image of the
        Tracking Technologies that we use.
      </p>
      <p>
        When a Tracking Technology contains personal data, our privacy policy
        applies as well.
      </p>
      <p ref="consent">
        <center><strong
          >Do We Need to Obtain my Consent for Using Tracking
          Technologies?</strong
        ></center>
      </p>
      <p>
        Yes, however only with respect to the Tracking Technologies that are not
        strictly essential for the operation of the Site.
      </p>
      <p>
        If you do not agree to accept our cookies or other Tracking Technologies
        that are not strictly essential for the operation of the Site, you can
        manage your tracking technologies preferences as described below.
      </p>
      <p ref="preferences"><center><strong>Can I Manage my Tracking Technologies Preferences?</strong></center></p>
      <p>Yes, through our Cookie Management Tool.</p>
      <p>
        In addition, every browser allows you to manage your Tracking
        Technologies preferences, usually found in the "Help" or
        &ldquo;Settings&rdquo; sections of the web browser.
      </p>
      <p>
        Here are some links to some commonly used web browsers: (a)
        <a
          href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&amp;hl=en"
          >Google Chrome</a
        >; (b)
        <a
          href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy"
          >Microsoft Edge</a
        >; (c)
        <a
          href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
          >Mozilla Firefox</a
        >; (d)
        <a
          href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies"
          >Microsoft Internet Explorer</a
        >; (e)
        <a href="https://www.opera.com/help/tutorials/security/privacy/"
          >Opera</a
        >; (f)
        <a href="https://support.apple.com/en-gb/safari">Apple Safari</a>.
      </p>
      <p>
        You can turn off certain third party targeting or advertising cookies by
        visiting the following link:&nbsp;<a
          href="http://www.networkadvertising.org/choices/"
          >Network Advertising Initiative</a
        >.
      </p>
      <p>
        To find out more about cookies, including how to see what cookies have
        been set, you can visit the following websites:&nbsp;<a
          href="http://www.aboutcookies.org/"
          >www.aboutcookies.org</a
        >&nbsp;and&nbsp;<a href="http://www.allaboutcookies.org/"
          >www.allaboutcookies.org</a
        >.
      </p>
      <p ref="updates"><center><strong>Will we Update this Policy?</strong></center></p>
      <p>
        We will update this policy, where needed. Every time we will update this
        policy we will post a notice on the Site, and obtain your consent once
        again, where required under applicable laws.
      </p>
      <p><em>Last updated: June 4, 2023.</em></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CookiePolicy",
  data() {
    return {};
  },
  mounted() {
    if (this.$route.hash) {
      setTimeout(() => {
        document.querySelector("h3" + this.$route.hash).scrollIntoView();
      }, 1000);
    }
  },
  methods: {
    scrollToRef(refName) {
      this.$refs[refName].scrollIntoView();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
table {
  border-collapse: collapse;
}

table,
th,
td {
  vertical-align: top;
}

tr {
  border-bottom: 1pt solid black;
}

tr:last-child {
  border-bottom: none;
}

td {
  padding-left: 2px;
  padding-right: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.region-heading {
  font-size: 2.5em;
  font-weight: normal;
  text-align: center;
  margin-bottom: 0.1em;
}
</style>



// WEBPACK FOOTER //
// src/components/CookiePolicy.vue